// /src/router/index.js
import { createRouter, createWebHashHistory } from "vue-router";
import ListDevicesPage from "../views/ListDevicesPage.vue";
import AddEditDevicePage from "../views/AddEditDevicePage.vue";

const routes = [
  {
    path: "/",
    name: "ListDevices",
    component: ListDevicesPage,
  },
  {
    path: "/device/add",
    name: "AddDevice",
    component: AddEditDevicePage,
  },
  {
    path: "/device/edit",
    name: "EditDevice",
    component: AddEditDevicePage,
  },
  {
    path: "/device/details/:deviceId",
    name: "MainDetailsDevicePage",
    component: () => import("../views/MainDetailsDevicePage.vue"),
    props: true,
  },
  {
    path: "/device/logs/:deviceId",
    name: "DeviceLogsPage",
    component: () => import("../views/DeviceLogsPage.vue"),
    props: true,
  },
  {
    path: "/device/settings/:deviceId",
    name: "SettingsPage",
    component: () => import("../views/SettingsPage.vue"),
    props: true,
  },
  {
    path: "/device/advanced/:deviceId",
    name: "AdvancedSettingsPage",
    component: () => import("../views/AdvancedSettingsPage.vue"),
    props: true,
  },
  {
    path: "/device/support/:deviceId",
    name: "SupportPage",
    component: () => import("../views/SupportPage.vue"),
    props: true,
  },
  {
    path: "/relays/details/:deviceId",
    name: "RelaysDetailsPage",
    component: () => import("../views/RelaysDetailsPage.vue"),
    props: true,
  },
  {
    path: "/device/contactsSettings/:deviceId",
    name: "ContactsSettingsPage",
    component: () => import("../views/ContactsSettingsPage.vue"),
    props: true,
  },
  {
    path: "/device/enableContact/:deviceId",
    name: "EnableContactPage",
    component: () => import("../views/EnableContactPage.vue"),
    props: true,
  },
  {
    path: "/device/alarmSettings/:deviceId",
    name: "AlarmSettingsPage",
    component: () => import("../views/AlarmSettingsPage.vue"),
    props: true,
  },
  {
    path: "/device/enableZone/:deviceId",
    name: "EnableZonePage",
    component: () => import("../views/EnableZonePage.vue"),
    props: true,
  },
  {
    path: "/device/wirelessZonesSettings/:deviceId",
    name: "WirelessZonesSettingsPage",
    component: () => import("../views/WirelessZonesSettingsPage.vue"),
    props: true,
  },
  {
    path: "/device/zoneAction/:deviceId/:zoneId",
    name: "ZoneActionPage",
    component: () => import("../views/ZoneActionPage.vue"),
    props: true,
  },
  {
    path: "/device/zonesList/:deviceId",
    name: "ZonesListPage",
    component: () => import("../views/ZonesListPage.vue"),
    props: true,
  },
  {
    path: "/relaysModeScreen/:deviceId",
    name: "RelaysModeScreen",
    component: () => import("../views/RelaysModeScreen.vue"),
    props: true,
  },
  {
    path: "/remoteSettingsScreen/:deviceId",
    name: "RemoteSettingsScreen",
    component: () => import("../views/RemoteSettingsScreen.vue"),
    props: true,
  },
  {
    path: "/timerSettingsScreen/:deviceId",
    name: "TimerSettingsScreen",
    component: () => import("../views/TimerSettingsScreen.vue"),
    props: true,
  },
];

const router = createRouter({
  history: createWebHashHistory(), // ← important: no `/` here
  routes,
});

export default router;
